export const SET_MY_COURSES_AND_SYLLABUSES_PAGE_INDEX = '@lms/SET_MY_COURSES_AND_SYLLABUSES_PAGE_INDEX';
export const SET_MY_COURSES_AND_SYLLABUSES_SORT = '@lms/SET_MY_COURSES_AND_SYLLABUSES_SORT_FIELD';
export const SET_MY_COURSES_AND_SYLLABUSES_SEARCH_QUERY = '@lms/SET_MY_COURSES_AND_SYLLABUSES_SEARCH_QUERY';
export const SET_MY_COURSES_AND_SYLLABUSES_FILTER_QUERY = '@lms/SET_MY_COURSES_AND_SYLLABUSES_FILTER_QUERY';
export const RESET_MY_COURSES_AND_SYLLABUSES_FILTER_QUERY = '@lms/RESET_MY_COURSES_AND_SYLLABUSES_FILTER_QUERY';

export const FETCH_MY_COURSES_AND_SYLLABUSES_REQUEST = '@lms/FETCH_MY_COURSES_AND_SYLLABUSES_REQUEST';
export const FETCH_MY_COURSES_AND_SYLLABUSES_SUCCESS = '@lms/FETCH_MY_COURSES_AND_SYLLABUSES_SUCCESS';
export const FETCH_MY_COURSES_AND_SYLLABUSES_FAILED = '@lms/FETCH_MY_COURSES_AND_SYLLABUSES_FAILED';
